import { LICENSE_MODULES, ROLES } from '../../../../../constants';

import ContactDetails from '../../v2/components/avg/contact-details';
import Suppliers from '../../v2/components/avg/suppliers';
import UserActivityLog from '../../v2/components/avg/user-activity-log';
import CompanyStructure from '../../v2/components/avg/company-structure';
import ShiftPositions from '../../v2/components/avg/shift-positions';
import ShiftTemplate from '../../v2/components/avg/shift-template';
import ShiftDay from '../../v2/components/avg/shift-day';
import UpsertShiftTemplate from '../../v2/components/avg/shift-template/upsert';
import ShiftPlan from '../../v2/components/avg/shift-plans/shift-base';
import ChoosePlant from '../../v2/components/avg/shift-plans/choose-plant';
import TeamShiftPlan from '../../v2/components/avg/team-shift-plan';
import PlannedValues from '../../v2/components/avg/planned-values';
import FabricData from '../../v2/components/avg/fabricData';
import Metrics from '../../v2/components/avg/metrics';
import RMVA from '../../v2/components/avg/RMVA';
import TRAS from '../../v2/components/avg/TRAS';
import monthlyValues from '../../v2/components/avg/monthly-values';
import Calendar from '../../v2/components/avg/calendar';
import Year from '../../v2/components/avg/year';
import LogBook from '../../v2/components/avg/log-book';
import ShiftLog from '../../v2/components/avg/shift-log';
import AddShiftLog from '../../v2/components/avg/shift-log/upsert-shift-log';
import EditShiftLog from '../../v2/components/avg/shift-log/upsert-shift-log';
import Teams from '../../v2/components/avg/teams';
import TeamDetails from '../../v2/components/avg/teams/team-details';
import EnergieWate from '../../v2/components/avg/energie-wate';
import CoverSheet from '../../v2/components/gmva/coverSheet';
import NewCoverSheet from '../../v2/components/gmva/newCoverSheet';
import PlantInput from '../../v2/components/gmva/plantInput';
import PlantInputGraphically from '../../v2/components/gmva/plantInputGraphically';
import PlantOutput from '../../v2/components/gmva/plantOutput';
import CommulationDailyQuantity from '../../v2/components/gmva/commulationDailyQuantity';
import Deckblatt from '../../v2/components/gmva/deckblatt';
import NewDeckblatt from '../../v2/components/gmva/newDeckblatt';

export default [
  {
    path: '/',
    name: 'home-gmva',
    redirect: '/gmva/shift-plans',
    meta: {
      title: '',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: '*',
    },
  },
  {
    path: '/gmva/company-structure',
    name: 'Contact details',
    component: CompanyStructure,
    meta: {
      title: 'Company Structure',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
    },
  },
  {
    path: '/gmva/teams',
    name: 'teams',
    component: Teams,
    meta: {
      title: 'teams',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
    },
  },
  {
    path: '/gmva/team-details/:id',
    name: 'team-details-gmva',
    component: TeamDetails,
    meta: {
      title: 'Team Details',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: '*',
    },
  },
  {
    path: '/gmva/create-team',
    name: 'create-team-gmva',
    component: TeamDetails,
    meta: {
      title: 'Create Team',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: '*',
      isGoBackBtn: true,
    },
  },
  {
    path: '/gmva/contact-details',
    name: 'Contact details',
    component: ContactDetails,
    meta: {
      title: 'Contact details',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER],
    },
  },
  {
    path: '/gmva/suppliers',
    name: 'Suppliers',
    component: Suppliers,
    meta: {
      title: 'Suppliers',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER],
    },
  },
  {
    path: '/gmva/user-activity-log',
    name: 'UserActivityLog',
    component: UserActivityLog,
    meta: {
      title: 'User Activity Log',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
    },
  },
  {
    path: '/gmva/shift-positions',
    name: 'Shift Positions',
    component: ShiftPositions,
    meta: {
      title: 'Shift Positions',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
    },
  },
  {
    path: '/gmva/shift-log',
    name: 'Shift Log',
    component: ShiftLog,
    meta: {
      title: 'Shift Log',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER, ROLES.USER],
    },
  },
  {
    path: '/gmva/planned-values',
    name: 'Planned Values',
    component: PlannedValues,
    meta: {
      title: 'Planned Values',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER],
    },
  },
  {
    path: '/gmva/fabric-data',
    name: 'Fabric Data',
    component: FabricData,
    meta: {
      title: 'Fabric Data',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER],
    },
  },
  {
    path: '/gmva/metrics',
    name: 'Metrics',
    component: Metrics,
    meta: {
      title: 'Metrics',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER],
    },
  },
  {
    path: '/gmva/RMVA',
    name: 'RMVA',
    component: RMVA,
    meta: {
      title: 'RMVA',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER],
    },
  },
  {
    path: '/gmva/monthly-values',
    name: 'monthly-values',
    component: monthlyValues,
    meta: {
      title: 'Monthly values',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER],
    },
  },
  {
    path: '/gmva/TRAS',
    name: 'TRAS',
    component: TRAS,
    meta: {
      title: 'TRAS',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER],
    },
  },
  {
    path: '/gmva/year',
    name: 'Year',
    component: Year,
    meta: {
      title: 'Years',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER],
    },
  },
  {
    path: '/gmva/calendar',
    name: 'Calendar',
    component: Calendar,
    meta: {
      title: 'Calendar',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER],
    },
  },
  {
    path: '/gmva/energie-wate',
    name: 'EnergieWate',
    component: EnergieWate,
    meta: {
      title: 'Energiewerte',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER],
    },
  },
  {
    path: '/gmva/log-book',
    name: 'Log Book',
    component: LogBook,
    meta: {
      title: 'Log Book',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER],
    },
  },
  {
    path: '/gmva/add-shift-log',
    name: 'Add Shift Log',
    component: AddShiftLog,
    meta: {
      title: 'Add Shift Log',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: '*',
      isGoBackBtn: true,
    },
  },
  {
    path: '/gmva/edit-shift-log/:id',
    name: 'edit-shift-log',
    component: EditShiftLog,
    meta: {
      title: 'Edit Shift Log',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: '*',
    },
  },
  {
    path: '/gmva/shift-template',
    name: 'shift-template',
    component: ShiftTemplate,
    meta: {
      title: 'Shift Template',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
    },
  },
  {
    path: '/gmva/new-shift-template',
    name: 'new-shift-template',
    component: UpsertShiftTemplate,
    meta: {
      title: 'Shift Template',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
      isGoBackBtn: true,
    },
  },
  {
    path: '/gmva/shift-day',
    name: 'shift-day',
    component: ShiftDay,
    meta: {
      title: 'Shift Day',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: '*',
      isGoBackBtn: true,
    },
  },
  {
    path: '/gmva/edit-shift-template/:id',
    name: 'edit-shift-template',
    component: UpsertShiftTemplate,
    meta: {
      title: 'Shift Template',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: '*',
    },
  },
  {
    path: '/gmva/shift-plans',
    name: 'Shift plans',
    component: ChoosePlant,
    meta: {
      title: 'Shift plans',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER, ROLES.USER],
    },
  },
  {
    path: '/gmva/team-shift-plan/:teamId',
    name: 'Team shift plan',
    component: TeamShiftPlan,
    meta: {
      title: 'Team shift plan',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: '*',
    },
  },
  {
    path: '/gmva/shift-plans/:id',
    name: 'shift-plant',
    component: ShiftPlan,
    meta: {
      title: 'Shift Plan',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER, ROLES.USER],
    },
  },
  {
    path: '/gmva/cover-sheet',
    name: 'cover-sheet',
    component: CoverSheet,
    meta: {
      title: 'Zusammenfassung Betriebstagebuch',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER, ROLES.USER],
    },
  },
  {
    path: '/gmva/new-cover-sheet',
    name: 'new-cover-sheet',
    component: NewCoverSheet,
    meta: {
      title: 'Neue Zusammenfassung Betriebstagebuch',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER, ROLES.USER],
      isGoBackBtn: true,
    },
  },
  {
    path: '/gmva/deckblatt',
    name: 'deckblatt',
    component: Deckblatt,
    meta: {
      title: 'Deckblatt',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER, ROLES.USER],
    },
  },
  {
    path: '/gmva/new-deckblatt',
    name: 'new-deckblatt',
    component: NewDeckblatt,
    meta: {
      title: 'Neues Deckblatt',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER, ROLES.USER],
      isGoBackBtn: true,
    },
  },
  {
    path: '/gmva/plant-input',
    name: 'Anlageninput',
    component: PlantInput,
    meta: {
      title: 'Anlageninput',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER, ROLES.USER],
    },
  },
  {
    path: '/gmva/plant-input-graphically',
    name: 'plant-input-graphically',
    component: PlantInputGraphically,
    meta: {
      title: 'Anlageninput graphisch',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER, ROLES.USER],
    },
  },
  {
    path: '/gmva/cumulation-daily-quantity',
    name: 'cumulation-daily-quantity',
    component: CommulationDailyQuantity,
    meta: {
      title: 'Anlageninput kumuliert',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER, ROLES.USER],
    },
  },
  {
    path: '/gmva/plant-output',
    name: 'plant-output',
    component: PlantOutput,
    meta: {
      title: 'Anlagenoutput',
      requiresAuth: true,
      module: LICENSE_MODULES.GMVA,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER, ROLES.USER],
    },
  },
];
